<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text px-10"
        v-on="on"
      >
        Create Disciplinary Action
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Disciplinary Action"
      text="Create Disciplinary Action"
      class="mb-0"
    > 
      <form>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"       
                outlined         
                data-vv-as="disciplinary action"                
                label="Disciplinary Action"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"  
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="white--text px-10"        
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        name: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()
      },
    },
    methods: { 
      prepareFormData () {
        return {
          name: this.name,
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
    
            this.$api.disciplinaryActions().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 200 || res.status === 201) {
                  this.$emit('created', res.data)                
                  this.$snack({ message: res.data.status })

                  this.dialog = false               
                }
              })
              .catch((err) => {
                if (err.response.status === 500) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                }            
            
                this.progressing = false
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
  
    },
  }
</script>
